const DB_NAME = 'graniot_preferences'
const STORE_NAME = 'metadata_visibility'
const DB_VERSION = 1

function openDB() {
	return new Promise((resolve, reject) => {
		const request = indexedDB.open(DB_NAME, DB_VERSION)
		request.onupgradeneeded = (event) => {
			const db = event.target.result
			if (!db.objectStoreNames.contains(STORE_NAME)) {
				db.createObjectStore(STORE_NAME)
			}
		}
		request.onsuccess = () => resolve(request.result)
		request.onerror = () => reject(request.error)
	})
}

export async function getVisibleMetadataKeys(userId) {
	try {
		const db = await openDB()
		return new Promise((resolve) => {
			const tx = db.transaction(STORE_NAME, 'readonly')
			const store = tx.objectStore(STORE_NAME)
			const request = store.get(String(userId))
			request.onsuccess = () => resolve(request.result || [])
			request.onerror = () => resolve([])
		})
	} catch {
		return []
	}
}

export async function setVisibleMetadataKeys(userId, keys) {
	try {
		const db = await openDB()
		return new Promise((resolve) => {
			const tx = db.transaction(STORE_NAME, 'readwrite')
			const store = tx.objectStore(STORE_NAME)
			store.put(keys, String(userId))
			tx.oncomplete = () => resolve()
			tx.onerror = () => resolve()
		})
	} catch {
		// degrade gracefully
	}
}
